import { ServiceBase } from '../api/ServiceBase';

const endpoint = 'motoristas'
const endpointLimited = 'limited'
const endpointdesativarOrAtivarMotorista = 'desativar_motorista'

/**
 * Método responsável buscar todos os motoristas na api
 */
async function getMotoristas(todos) {
    try {

        var data = await ServiceBase.getByParams(`${endpoint}/${endpointLimited}`, { 'is_ativo': todos ? 'True' : 'False' });
        return data;
    } catch (e) {
        throw e;
    }
}

async function getMotoristaById(id) {
    try {
        var data = await ServiceBase.getByParams(`${endpoint}/${id}`);
        return data;
    } catch (e) {
        throw e;
    }
}

async function postMotorista(motorista) {
    try {
        var data = await ServiceBase.postData(endpoint, motorista)
        return data;
    } catch (e) {
        throw e;
    }
}

async function putMotorista(motorista) {
    try {
        var data = await ServiceBase.putData(`${endpoint}/${motorista.id}/`, motorista)
        return data;
    } catch (e) {
        throw e;
    }
}

async function desativarOrAtivarMotorista(id, ativar) {
    try {
        var data = await ServiceBase.putData(`${endpoint}/${endpointdesativarOrAtivarMotorista}/`, { 'id': id, 'is_ativo': ativar ? 'True' : 'False' })
        return data;
    } catch (e) {
        throw e;
    }
}

export const MotoristaService = {
    getMotoristas,
    getMotoristaById,
    postMotorista,
    putMotorista,
    desativarOrAtivarMotorista
}